import { render, staticRenderFns } from "./goodsorder.vue?vue&type=template&id=3a4cf5ac&scoped=true"
import script from "./goodsorder.vue?vue&type=script&lang=js"
export * from "./goodsorder.vue?vue&type=script&lang=js"
import style0 from "./goodsorder.vue?vue&type=style&index=0&id=3a4cf5ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4cf5ac",
  null
  
)

export default component.exports